document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-bottom-nav-search]');
  if (!trigger) return;

  // Delegates to the existing header predictive-search overlay (<details-modal
  // class="header__search"><details><summary>...) instead of building a second one.
  // Two instances render in sections/header.liquid; Dawn's CSS makes the one nested
  // inside .header__icons the visible one below 990px, which is the only breakpoint
  // band bottom-nav ever renders in.
  const summary = document.querySelector('.header__icons details-modal.header__search summary');
  if (summary) summary.click();
});
